import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "sidebar-area-toggle"

export default class extends Controller {
  static targets = ["adminItems", "customerItems", "adminButton", "customerButton"]

  connect() {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === "admin") {
      this.showAdmin()
    } else if (saved === "customer") {
      this.showCustomer()
    }
  }

  showAdmin() {
    this.adminItemsTarget.classList.remove("hidden")
    this.customerItemsTarget.classList.add("hidden")
    this.adminButtonTarget.className = this.activeClasses
    this.customerButtonTarget.className = this.inactiveClasses
    localStorage.setItem(STORAGE_KEY, "admin")
  }

  showCustomer() {
    this.customerItemsTarget.classList.remove("hidden")
    this.adminItemsTarget.classList.add("hidden")
    this.customerButtonTarget.className = this.activeClasses
    this.adminButtonTarget.className = this.inactiveClasses
    localStorage.setItem(STORAGE_KEY, "customer")
  }

  get activeClasses() {
    return "flex-1 text-center py-1.5 text-sm font-medium transition-all duration-200 bg-white/20 text-white cursor-pointer"
  }

  get inactiveClasses() {
    return "flex-1 text-center py-1.5 text-sm font-medium transition-all duration-200 bg-white/5 text-white/50 hover:bg-white/10 hover:text-white/80 cursor-pointer"
  }
}
